import { storeToRefs } from 'pinia';
import { alternativeProductsModalStore } from '~/stores/alternativeProductsModal';

export default function () {

  const store = alternativeProductsModalStore();

  const isAlternativeProductsModalOpen = computed(() => {

    const isOpen = store.alternativeProductsModalState !== null;

    return isOpen;
  
  });

  function openAlternativeProductsModal() {

    store?.setAlternativeProductsModalState({ open: true });
  
  }

  function closeAlternativeProductsModal() {

    store.setAlternativeProductsModalState(null);
  
  }

  return {
    ...store,
    isAlternativeProductsModalOpen,
    openAlternativeProductsModal,
    closeAlternativeProductsModal,
  };

}